import http from '@/assets/js/http'
import {
  baseSmile
} from '@/assets/js/base-url.js'

const getterResultsCache = {};

export default {
  namespaced: true,
  state: {
    searchLoading: false,
    apiCommonUrl: `${baseSmile}/common-rules/`,
    apiExceptionUrl:`${baseSmile}/exception-rules/`,
    checkingRouter: [],
    ruleAllHeader: [],
    plantDC: [],
    rules: [],
    conflictFlag: false,
    conflictData: [],
    addDialogFlag: false,
    editDialogFlag: false,
    suggestionRule:[],
    firstLevelDisabled: ''
  },
  mutations: {
    setCheckingRouter(state, newVal) {
      state.checkingRouter = newVal
    },
    setRuleAllHeader(state, newVal) {
      state.ruleAllHeader = newVal
    },
    setPlantDC(state, newVal) {
      state.plantDC = newVal
    },
    setRule(state, newVal) {
      state.rules = newVal
    },
    setAddDialogFlag(state, newVal) {
      state.addDialogFlag = newVal
    },
    setConflictFlag(state, newVal) {
      state.conflictFlag = newVal
    },
    setConflictData(state, newVal) {
      state.conflictData = newVal
    },
    setSearchLoading(state, newVal) {
      state.searchLoading = newVal
    },
    setEditDialogFlag(state, newVal) {
      state.editDialogFlag = newVal
    },
    setSuggestionRule(state, newVal){
      state.suggestionRule = newVal
    },
    setFirstLevelDisabled(state, newVal){
      state.firstLevelDisabled = newVal
    }
  },
  actions: {
    getPlantDC(ctx) {
      http.get(`${baseSmile}/plant_dc/`).then(resp => {
        ctx.commit("setPlantDC", resp.data)
      }).catch(error => {
        this._vm.$notify({
          title: 'Plant DC',
          message: error,
          type: 'error',
          duration: 5000
        })
      });
    },
    getCheckingRouter(ctx) {
      http.get(`${baseSmile}/checking_router/`).then(resp => {
        ctx.commit("setCheckingRouter", resp.data)
      }).catch(error => {
        this._vm.$notify({
          title: 'Checking Router',
          message: error,
          type: 'error',
          duration: 5000
        })
      });

    },
    getRuleAllHeader(ctx,payload) {
      ctx.commit('setRule', [])
      ctx.commit('setSearchLoading', true)
      ctx.commit('setRuleAllHeader', [])
      http.get(`${baseSmile}/table-configs/`, payload).then(resp => {
        ctx.commit('setRuleAllHeader', resp.data)
        ctx.dispatch('getRules',payload)
      }).catch(error => {
        console.error('Error', error)
      }).finally(() => {
        ctx.commit('setSearchLoading', false)
      })
    },
    getRules(ctx, filterData) {
      ctx.commit('setSearchLoading', true)
      http.get(ctx.state.apiCommonUrl, filterData).then(resp => {
        ctx.commit('setRule', resp.data)
      }).catch(error => {
        this._vm.$notify({
          title: 'error',
          message: error,
          type: 'error',
          duration: 5000
        })
      }).finally(() => {
        ctx.commit('setSearchLoading', false)
      })
    },
    CRule(ctx, formData) {
      http.post(ctx.state.apiCommonUrl, formData).then(resp => {
        ctx.commit('setAddDialogFlag', false)
        this._vm.$notify({
          title: 'success',
          message: 'Rule Sumbited',
          type: 'success',
          duration: 5000
        })
        ctx.dispatch('getRules',{rule_type:formData.rule_type})
      }).catch(error => {
        if (error.response.status == 409) {
          ctx.commit('setConflictFlag', true)
          ctx.commit('setConflictData', error.response.data)
        }
        this._vm.$notify({
          title: 'error',
          message: '操作失败，请联系Golden PIPE Ion 寻求帮助',
          type: 'error',
          duration: 5000
        })
      })
    },
    CException(){
      http.post(ctx.state.apiExceptionUrl, formData).then(resp => {
        ctx.commit('setAddDialogFlag', false)
        this._vm.$notify({
          title: 'success',
          message: 'Rule Sumbited',
          type: 'success',
          duration: 5000
        })
        ctx.dispatch('getRules',{rule_type:formData.rule_type})
      }).catch(error => {
        if (error.response.status == 409) {
          ctx.commit('setConflictFlag', true)
          ctx.commit('setConflictData', error.response.data)
        }
        this._vm.$notify({
          title: 'error',
          message: '操作失败，请联系Golden PIPE Ion 寻求帮助',
          type: 'error',
          duration: 5000
        })
      })
    }
    ,
    updateRule(ctx, payload) {
      http.put(ctx.state.apiCommonUrl + payload.id + '/', payload).then(resp => {
        ctx.commit('setEditDialogFlag', false)
        this._vm.$notify({
          title: 'success',
          message: 'Rule Updated',
          type: 'success',
          duration: 5000
        })
        ctx.dispatch('getRules',{rule_type:payload.rule_type})
      }).catch(error => {
        this._vm.$notify({
          title: 'error',
          message: '操作失败，请联系Golden PIPE Ion 寻求帮助',
          type: 'error',
          duration: 5000
        })
      });
    },
    deleteCommonRuleById(ctx, payload) {
      const {
        id,
        router_id,rule_type
      } = payload
      http.delete(ctx.state.apiCommonUrl + id + '/?router_id='+router_id).then(resp => {
        this._vm.$notify({
          title: 'success',
          message: 'Rule Deleted',
          type: 'success',
          duration: 5000
        })
        ctx.dispatch('getRules',{rule_type:rule_type})
      }).catch(error => {
        this._vm.$notify({
          title: 'error',
          message: '操作失败，请联系Golden PIPE Ion 寻求帮助',
          type: 'error',
          duration: 5000
        })
      });
    },
    // 批量删除
    deleteBatch(ctx, { items = [], rule_type }) {
      if (!Array.isArray(items) || items.length === 0) return Promise.resolve();
      return http.post(ctx.state.apiCommonUrl + 'batch-destroy/', { items })
        .then(() => {
          this._vm.$notify({
            title: 'success',
            message: 'Deleted',
            type: 'success',
            duration: 5000
          });
          if (rule_type) {
            ctx.dispatch('getRules', { rule_type });
          }
        })
        .catch(error => {
          this._vm.$notify({
            title: 'error',
            message: '批量删除失败，请联系Golden PIPE Ion',
            type: 'error',
            duration: 5000
          });
          return Promise.reject(error);
        });
    },
    operation(ctx, parms) {
      http.put(ctx.state.apiCommonUrl + 'operation/', parms).then(resp => {
        this._vm.$notify({
          title: 'success',
          message: 'Opeartions Success',
          type: 'success',
          duration: 5000
        })
        ctx.dispatch('getRules', {rule_type:parms.rule_type})
      }).catch(error => {
        console.error('Error', error)
      })
    },
    querySearchAsync(ctx, {
      queryString,
      callback = () => {}
    }) {
      // 发送 AJAX 请求到后端 Django 服务器
      return http.get(ctx.state.apiCommonUrl, {
          id: queryString,rule_type:'tabCommonRule'
        })
        .then(response => {
          // 处理后端返回的查询结果
          ctx.commit('setSuggestionRule', response.data)
          callback(response.data)
        })
        .catch(error => {
          console.error(error)
          callback([])
        })
    },
    debounceQueryRule(ctx, {
      queryString,
      callback
    }) {
      clearTimeout(window._debounceTimer)
      window._debounceTimer = setTimeout(() => {
        ctx.dispatch('querySearchAsync', {
          queryString,
          callback
        })
      }, 1200)
    },
    plantField(ctx, parms) {
      return http.get(`${baseSmile}/check_plant/`, parms)
    },
  },
  getters: {
    plantList(state) {
      if (state.checkingRouter.length > 0) {
        let uniquePlants = state.plantDC.reduce((acc, {
          plant,checking_model
        }) => {
          acc.add({'plant':plant,'checking_model':checking_model})
          return acc
        }, new Set())
        return Array.from(uniquePlants)
      } else return state.checkingRouter
    },
    routerType: (state) => (router_type) => {
      if (state.checkingRouter.length > 0) {
        let router_types = []
        if (router_type == 'cn_categories') {
          router_types = state.checkingRouter.reduce((acc, item) => {
            return acc.concat(item.cn_categories);
          }, []);
        } else router_types = state.checkingRouter.map(item => item[router_type]);
        const unique = Array.from(new Set(router_types));
        return unique.map(value => ({
          value: value,
          label: value
        }))
      } else return []
    },
    transformToCascaderInput: (state, getters) => (attribute_level,) => {
      const cacheKey = attribute_level + JSON.stringify(state.checkingRouter)+state.firstLevelDisabled;
      const cachedResult = getterResultsCache[cacheKey];
      if (cachedResult) {
        return cachedResult;
      }
      if (state.checkingRouter.length > 0) {
        const cascaderData = [];
        const tempData = {};

        // 遍历原始数据
        state.checkingRouter.forEach(entry => {
          const checkingModel = entry["checking_model"];
          const checkingPurpose = entry["checking_purpose"];
          const categories = entry["cn_categories"];

          // 如果该模型不在临时数据中，添加它
          if (!tempData[checkingModel]) {
            tempData[checkingModel] = {
              label: checkingModel,
              value: checkingModel,
              children: [],
              disabled: state.firstLevelDisabled==''?false: checkingModel == state.firstLevelDisabled?false:true
            };
          }

          // 查找或创建目的项
          let purposeItem = tempData[checkingModel].children.find(item => item.label === checkingPurpose);
          if (!purposeItem) {
            purposeItem = {
              label: checkingPurpose,
              value: checkingPurpose,
              children: []
            };
            tempData[checkingModel].children.push(purposeItem);
          }

          // 添加分类到目的项
          categories.forEach(category => {
            let categoryItem = purposeItem.children.find(item => item.label === category);
            if (!categoryItem) {
              categoryItem = {
                label: category,
                value: category,
              };
              if (attribute_level === 'Plant') {
                // Only add plants where the checking model matches
                categoryItem.children = [];
                getters.plantList
                  .filter(plantEntry => plantEntry.checking_model === checkingModel)
                  .forEach(plantEntry => {
                    // Only add plant if it does not already exist in children
                    if (!categoryItem.children.some(child => child.label === plantEntry.plant)) {
                      categoryItem.children.push({
                        label: plantEntry.plant,
                        value: plantEntry.plant
                      });
                    }
                  });
              }
              purposeItem.children.push(categoryItem);
            }

          });
        });

        // 转换tempData为数组
        Object.values(tempData).forEach(item => cascaderData.push(item));
        getterResultsCache[cacheKey] = cascaderData
        return cascaderData;
      } else return []
    },
    flatRules(state) {
      const transformedRules = [];
    
      // Loop through each rule in the state
      state.rules.forEach(rule => {
        const { apply_to, ...rest } = rule;
    
        // Intermediate structure to group apply_to by checkingmode
        const groupedByCheckingMode = {};
    
        // Group apply_to items by checkingmode
        apply_to.forEach(item => {
          const { checking_model,checking_purpose, ...applyItemRest } = item;
          const router_key = checking_model+','+checking_purpose
          if (!groupedByCheckingMode[router_key]) {
            groupedByCheckingMode[router_key] = [];
          }
    
          groupedByCheckingMode[router_key].push(applyItemRest);
        });
    
        // Convert the intermediate structure back to the desired format
        Object.keys(groupedByCheckingMode).forEach(router => {
          transformedRules.push({
            ...rest,
            checking_model: router.split(',')[0],
            checking_purpose: router.split(',')[1],
            apply_to: groupedByCheckingMode[router]
          });
        });
      });
    
      return transformedRules;
    }
  },
  modules: {}
}



// WEBPACK FOOTER //
// ./src/store/smile/smile_configuration.js